<template>
    <SOSlotBase :bg-white="true" :container-name="'pengaturan-laporan'" :loading="isLoading">
        <template v-slot:loading-page>
            <SOLoadingPage />
        </template>

        <template v-slot:title-bar>
            <SOTitleBar :page-title="'Pengaturan Riwayat Biaya Kasir'" :type="'back'" @back="back" />
        </template>

        <template v-slot:content>
            <div class="p-x-20 p-t-16 pengaturan-laporan">
                <p class="m-d-12">
                    Anda dapat menyembunyikan laporan kasir saat kasir selesai melakukan laporan pengeluaran biaya
                </p>

                <div class="separator m-x-min m-d-20"></div>

                <div class="m-d-16 m-t-16">
                    <div class="m-d-12">
                        <SOToggleOnOff
                            check-id="sumber-dana"
                            check-title="Sumber Dana"
                            nama="sumber-dana"
                            :is-checked='dataCheck["sumber-dana"]'
                            @selected="onToggleCheck($event, 'sumber-dana')"
                        />
                    </div>
                    <p class="m-d-0">
                        Daftar semua kas yang terdaftar di Akun owner, pilih Sumber dana yang ingin di sembunyikan di
                        Laporan Kasir
                    </p>
                    <div
                        v-if="selectedSumberDana.length > 0"
                        class="detail-data m-t-16 d-flex-between-center"
                        style="align-items: start"
                    >
                        <div class="">
                            <div v-for="(dana, idx) in selectedSumberDana" :key="`dana-${idx}`">
                                <p class="m-d-4" v-if="idx < 5">
                                    {{ dana.nama_akun }}
                                </p>
                            </div>
                        </div>
                        <div class="" @click="openPilihItem('sumber-dana')">
                            <SOIconBase viewBox="0 0 20 19" width="20" height="19">
                                <template v-slot:icon>
                                    <PencilEdit2019 />
                                </template>
                            </SOIconBase>
                        </div>
                    </div>
                </div>

                <div class="separator-line m-x-min m-d-20"></div>

                <div class="m-d-16 m-t-16">
                    <div class="m-d-12">
                        <SOToggleOnOff
                            check-id="item-biaya"
                            check-title="Akun Biaya"
                            nama="item-biaya"
                            :is-checked='dataCheck["item-biaya"]'
                            @selected="onToggleCheck($event, 'item-biaya')"
                        />
                    </div>
                    <p class="m-d-0" >
                        Daftar semua kas yang terdaftar di Akun owner, pilih Sumber dana yang ingin di sembunyikan di
                        Laporan Kasir
                    </p>
                    <div
                        v-if="selectedItemBiaya.length > 0"
                        class="detail-data m-t-16 d-flex-between-center"
                        style="align-items: start"
                    >
                        <div>
                            <div v-for="(item, key) in selectedItemBiaya" :key="`item-${key}`">
                                <p class="m-d-4" v-if="key < 5">
                                    {{ item.nama }}
                                </p>
                            </div>
                        </div>
                        <div class="" @click="openPilihItem('item-biaya')">
                            <SOIconBase viewBox="0 0 20 19" width="20" height="19">
                                <template v-slot:icon>
                                    <PencilEdit2019 />
                                </template>
                            </SOIconBase>
                        </div>
                    </div>
                </div>
                <div class="separator-line m-x-min m-d-20"></div>
            </div>
        </template>
    </SOSlotBase>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { moduleName } from "../store/state";

import SOSlotBase from "@/so-components/global/slot/SOSlotBase";
import SOLoadingPage from "@/so-components/global/ui/SOLoadingPage";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar";

import SOToggleOnOff from "@/so-components/global/input/SOToggleOnOff.vue";

import SOIconBase from "@/so-components/global/icons/SOIconBase.vue";
import PencilEdit2019 from "@/so-components/global/icons/iconPacks/PencilEdit2019.vue";

export default {
    name: "PengaturanLaporan",
    components: {
        SOSlotBase,
        SOLoadingPage,
        SOTitleBar,
        SOToggleOnOff,
        SOIconBase,
        PencilEdit2019,
    },
    data() {
        return {
            isLoading: false,
            dataCheck:{
                "sumber-dana":false,
                "item-biaya":false,
            },
        };
    },
    mounted() {
        this.init();
    },
    computed: {
        ...mapGetters(moduleName, {
            pengaturanLaporan: "pengaturanLaporan",
        }),
        getItemBiaya() {
            return this.pengaturanLaporan.itemBiaya;
        },
        selectedItemBiaya() {
            let selectedItem = this.getItemBiaya.filter((item) => item.hide === 1);
            return selectedItem ? selectedItem : 0;
        },
        getSumberDana() {
            return this.pengaturanLaporan.sumberDana;
        },
        selectedSumberDana() {
            let selectedDana = this.getSumberDana.filter((item) => item.hide === 1);
            return selectedDana ? selectedDana : 0;
        },
    },
    methods: {
        ...mapActions({
            getPengaturanLaporan: `${moduleName}/getPengaturanLaporan`,
            setSumberDana: `${moduleName}/setSumberDana`,
            setItemBiaya: `${moduleName}/setItemBiaya`,
        }),
        back() {
            this.$router.back();
        },
        onToggleCheck(value, target) {
            if(target==="sumber-dana"){
                value=this.selectedSumberDana.length > 0
            }else{
                value=this.selectedItemBiaya.length > 0
            }
            this.dataCheck[target] = value;
            this.openPilihItem(target)
        },
        openPilihItem(val) {
            this.$router.push({ name: "pengaturanUmum.pengaturan-laporan.pilih-item", params: { pengaturan: val } });
        },
        async init() {
            await this.getListData();
        },
        getListData() {
            this.isLoading = true;
            this.getPengaturanLaporan()
                .then((res) => {
                    if (!res.data) {
                        this.$toast.error(res);
                    } else {
                        let { code, status, data, msg } = res.data;
                        if (status && code === 200) {
                            this.setSumberDana(data.sumberDana);
                            this.setItemBiaya(data.itemBiaya);
                        }
                    }
                    this.isLoading = false;
                })
                .catch((e) => {
                    this.isLoading = false;
                    this.$toast.error(e);
                });
        },
    },
};
</script>

<style scoped>
.pengaturan-laporan .separator {
    width: unset;
}
.pengaturan-laporan .detail-data {
    border: 1px solid #c8d0dd;
    box-sizing: border-box;
    border-radius: 4px;
    padding: 10px 16px;
}
</style>
